import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=718d13ee&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&id=718d13ee&scoped=true&lang=css&"
import style1 from "./Details.vue?vue&type=style&index=1&id=718d13ee&lang=less&scoped=true&"
import style2 from "./Details.vue?vue&type=style&index=2&id=718d13ee&lang=less&scoped=true&"
import style3 from "./Details.vue?vue&type=style&index=3&id=718d13ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d13ee",
  null
  
)

export default component.exports